import { ExclamationCircleIcon } from '@heroicons/react/24/outline'

import { RequestForQuote } from '../../types'
import { StoreOrder } from '../types'

import MoneyM from '@/gf/modules/Money'
import StoreOrderM from '../modules/StoreOrder'
import TimeM from '@/gf/modules/Time'

import Card from '@/gf/components/Card'

const CompetingOfferCard = ({
  storeOrder,
  rfq,
}: {
  storeOrder: Pick<
    StoreOrder,
    | 'id'
    | 'insertedAt'
    | 'lineItems'
    | 'shippingAmount'
    | 'timingDetails'
    | 'convenienceFeeRate'
    | 'additionalCharges'
    | 'salesTax'
  >
  rfq: Pick<RequestForQuote, 'insertedAt'>
}) => (
  <Card
    className="border-green-300 shadow-green-200 border-2"
    key={storeOrder.id}
    title={
      <div className="flex flex-row space-x-2 items-center">
        <div className="rounded-full">
          <ExclamationCircleIcon className="w-8 h-8 -m-1" />
        </div>
        <p className="font-bold">Another supplier won the business</p>
      </div>
    }
  >
    <Card.Section>
      <Card.SubSection>
        <div className="flex space-x-4">
          <div className="text-sm text-gray-700 flex flex-1 flex-col">
            {storeOrder.lineItems.map((item) => (
              <div className="flex justify-between text-sm text-gray-700" key={item.id}>
                <span>Item Price x Quantity</span>
                <span>
                  {MoneyM.format(item.discountedUnitPrice)} x {item.quantity}
                </span>
              </div>
            ))}
            <div className="flex justify-between text-sm text-gray-700">
              <span className="font-bold">Shipping</span>
              <span>{MoneyM.format(storeOrder.shippingAmount)}</span>
            </div>
            <div className="flex justify-between text-sm text-gray-700">
              <span className="font-bold">Total</span>
              <span>{MoneyM.format(StoreOrderM.total(storeOrder))}</span>
            </div>
            <div className="pt-4 flex justify-between text-sm text-gray-700">
              <span className="font-bold text-green-500">Supplier time to quote</span>
              <span className="font-bold text-green-500 animatetext">
                {TimeM.formatDiff(rfq.insertedAt, storeOrder.insertedAt)}
              </span>
            </div>
          </div>
        </div>
      </Card.SubSection>
    </Card.Section>
    {storeOrder.timingDetails && (
      <Card.Section title="Expected shipping/lead time">
        <p className="text-sm text-gray-700 whitespace-pre-wrap">{storeOrder.timingDetails}</p>
      </Card.Section>
    )}
  </Card>
)

export default CompetingOfferCard
